
import { Link } from "react-router-dom";
import veneer from "../../Images/veneer.jpg";
import veneer1 from "../../Images/veneer1.jpg";
import veneer2 from "../../Images/veneer2.jpg";
import veneer3 from "../../Images/veneer3.jpg";
import veneer4 from "../../Images/veneer4.jpg";


import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";


export default function Veneers() {
  return (
    <>
    <div
  className=" relative w-full min-h-[300px] sm:min-h-[400px] lg:min-h-[350px]
    bg-cover bg-[center_50%] flex items-center pt-28 sm:pt-32 "
  style={{ backgroundImage: `url(${veneer})` }}
>
  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-black/55"></div>

  {/* Content */}
  <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <h1
      className=" text-white font-extrabold text-center text-3xl sm:text-2xl md:text-3xl lg:text-3xl xl:text-4xl
        leading-tight pt-5 pb-1 max-w-5xl -mt-12 sm:mt-0 mx-auto drop-shadow-[0_6px_20px_rgba(0,0,0,0.7)]" >
      Veneers - Before and After
    </h1>
  </div>
  </div>

<div className=" px-2 py-2 mt-12">
  <div className="max-w-7xl mx-auto px-6">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">

        {/* left Image */}
      <div>
        <img
          src={veneer1}
          alt="Dental Consultation"
          className="w-full h-[380px] object-cover rounded-2xl"
        />
      </div>

      {/* right Content */}
      <div>
        <h1 className="text-3xl font-semibold text-[#0a0a5c] mb-3">
          Do you have a “gorgeous smile”?
        </h1>

        <p className="text-gray-700 ">
        You might be surprised to know that even if your teeth are not 100% perfect, veneers might be able to give you the beautiful smile you’ve always wanted. Imagine having the confidence to show your smile to the world – without feeling self-conscious or embarrassed. Check out our before and after gallery to see real results from some of our patients.        </p>

      </div>
</div>
  </div>
</div>

<div className="max-w-7xl mx-auto px-4 py-10">
  <h2 className="text-center text-3xl font-semibold text-[#0a0a5c] mb-8">
    Porcelain Veneers - Before and After Pictures
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 items-start">

    {/* Column 1 */}
    <div className="space-y-2">
      <img
        src={veneer2}
        alt="Before"
        className="w-full h-[380px] object-cover rounded-lg"
      />
      <p className="text-center text-gray-700 mt-2">
      This patient had gaps between her teeth, and veneers were used to close the gaps and give her a more uniform smile.      </p>
      
    </div>

    {/* Column 2 */}
    <div className="space-y-2">
      <img
        src={veneer3}
        alt="Veneer"
        className="w-full h-[380px] object-cover rounded-lg"
      />
      <p className="text-center text-gray-700 mt-2">
        This patient was unhappy with the colour, shape, and size of her teeth. Veneers were used to give her an overall more uniform and aesthetically pleasing smile.
      </p>
      {/* placeholder to keep same height */}
      
    </div>

    {/* Column 3 */}
    <div className="space-y-2">
      <img
        src={veneer4}
        alt="Veneer"
        className="w-full h-[380px] object-cover rounded-lg"
      />
      <p className="text-center text-gray-700 mt-2">
        This patient had a mismatched shape and size of his teeth. His smile was enhanced with veneers to give him a more uniform and aesthetically appealing appearance.

      </p>
      
      
    </div>
</div>
</div>


<div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 md:grid-cols-2 gap-10">
  {/* Left Column */}
  <div>
    <h3 className="text-3xl font-semibold text-[#0a0a5c] mb-4">
      Things to Know Before You Get Porcelain Veneers
    </h3>
    <p className="text-gray-700 mb-4">
      Trying to decide if porcelain veneers are right for you? Here are a few things to keep in mind:
    </p>
    <ol className="list-decimal list-outside text-gray-700 space-y-2 mb-4">
      <li>Treatment with porcelain veneers is usually irreversible. This means that once your natural tooth enamel is removed, it cannot be put back.</li>
      <li>Porcelain veneers are not for everyone. In order to be a candidate for this treatment, you must have healthy teeth and gums.</li>
      <li>You should also have a good bite (occlusion) and enough tooth structure to support the veneers.</li>
      <li>Porcelain veneers are a cosmetic treatment. This means that they are not covered by most dental insurance plans.</li>
      <li>Porcelain veneers are durable, but they are not indestructible. You should avoid biting your nails, chewing on hard objects (ice, hard candy, etc.), and grinding your teeth.</li>
      <li>Porcelain veneers can last for many years, but they may eventually need to be replaced.</li>
    </ol>
    <p className="text-gray-700">
      If you are considering porcelain veneers, be sure to talk to one of our experienced dentists about whether or not this treatment is right for you.
    </p>
  </div>

  {/* Right Column */}
  <div>
    <h3 className="text-3xl font-semibold text-[#0a0a5c] mb-4">
      Things to Know After Your Get Porcelain Veneers
    </h3>
    <p className="text-gray-700 mb-4">
      Porcelain veneers are a beautiful way to enhance your smile. Here are a few things to keep in mind after you get your new veneers:
    </p>
    <ol className="list-decimal list-outside text-gray-700 space-y-2 mb-4">
      <li>Your teeth may be sensitive for a few days after treatment. This is normal and should go away within a week or so.</li>
      <li>You may need to adjust your diet for a few days while your teeth adjust to the veneers. Avoid hard, crunchy, or sticky foods that could damage the veneers.</li>
      <li>Be sure to brush and floss your teeth twice a day and see your dentist regularly for checkups and cleanings.</li>
      <li>If you grind your teeth or clench at night, you may need to wear a mouth guard to protect your veneers.</li>
    </ol>
    <p className="text-gray-700">
      If you have any questions or concerns about your porcelain veneers, be sure to talk to one of our experienced dentists. We are here to help you!
    </p>
  </div>
</div>

<div className="w-full h-[180px] overflow-hidden mt-4">
  <iframe
    title="clinic-map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.0390050498395!2d71.9162331!3d30.292951199999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393b557588a60575%3A0x79afa5462675bee1!2sSmile%20expert%20dental%20clinic!5e0!3m2!1sen!2s!4v1767274320473!5m2!1sen!2s"
    width="100%"
    height="450"
    style={{ border: "0" }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</div>

<div className="bg-[#0c2340] text-white pt-[60px] pb-[60px] px-[40px] mt-0">
  <div className="flex justify-between flex-wrap max-w-[1400px] mx-auto gap-[40px]">
    {/* COLUMN 1 */}
    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Useful Links</h3>

  <Link to="/about/meet-our-team" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    About Us
  </Link>

  <Link to="/contact" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Contact Us
  </Link>

  <Link to="/about/meet-our-team" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Meet the Team
  </Link>

  <Link to="/teeth-whitening-before-and-after" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Before & After
  </Link>

  <Link to="/blog" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Blogs
  </Link>
</div>


    
    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Treatments</h3>

  <Link to="/treatment/exam" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Exam & X-Rays Check-Up
  </Link>

  <Link to="/emergency-dentist" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Emergency
  </Link>

  <Link to="/t/implants" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Smile Makeover
  </Link>

  <Link to="/t/veneer" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Veneers
  </Link>

  <Link to="/t/implants" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Implants
  </Link>

  <Link to="t/canals" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Root Canal Treatment
  </Link>

  <Link to="/t/orthodontist" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Orthodontic Braces
  </Link>

  
</div>


    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Dental Problems</h3>

  <Link to="/yellow-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Yellow Teeth
  </Link>

  <Link to="/teeth-cleaning" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Teeth Cleaning
  </Link>

  <Link to="/missing-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Missing Teeth
  </Link>

  <Link to="/broken-chipped-tooth" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Broken Chipped Tooth
  </Link>

  <Link to="/gum-disease" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Gum Disease
  </Link>

  <Link to="/crooked-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Crooked Teeth
  </Link>

  <Link to="/sore-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Sensitive & Sore Teeth
  </Link>

  <Link to="/dental-anxiety" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Anxiety
  </Link>
</div>


    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Patient Safety</h3>

  <Link to="/7x-safety" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    7X SAFETY
  </Link>

  <Link to="/4-step-sterilization" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    4 Step Sterilization
  </Link>

  <Link to="/safety-equipment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Safety Equipment
  </Link>

  <Link to="/equipment-technology" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Equipment & Technology
  </Link>

  <Link to="/quality" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Quality
  </Link>
</div>


    <div className="min-w-[250px]">
              <h3 className="text-[20px] mb-[20px]">Get in touch</h3>
        
              <p className="my-2 flex gap-[10px] ">📧 aneelabrar555@gmail.com</p>
        
              <p className="my-3 flex gap-[10px]  ">📞 03008395562</p>
        
              <p className="my-2 flex gap-[10px] px-2">
                  <span className="">📍 Saddique Hospital Stadium Road Khanewal</span>
              </p>
        
              <p className="mt-6 font-semibold "> 🕒 Clinic Timing <br/>   <span className="ml-7">11:00am to 9:00pm</span></p>
        
              <div className="text-left bg-[#0c2340] text-white py-[50px] px-[20px]">
                <div className="flex gap-[15px] mt-[20px]">
                  <a

                      href="https://www.facebook.com/share/17zJppb7qh/"

                      target="_blank"

                      rel="noopener noreferrer"

                      className="w-[35px] h-[35px] bg-blue-900 flex justify-center items-center rounded-[8px] no-underline"

                      aria-label="Follow us on Facebook"

                    >

                      <FaFacebookF size={20} color="white" />
                  </a>
        
                  <a

        
                      href="https://instagram.com"

        
                      target="_blank"

        
                      rel="noopener noreferrer"

        
                      className="w-[35px] h-[35px] bg-[#000000] flex justify-center items-center rounded-[8px] no-underline"

        
                      aria-label="Follow us on Instagram"

        
                    >

        
                      <FaInstagram size={20} color="white" />
                  </a>
        
                  <a

        
                      href="https://youtube.com"

        
                      target="_blank"

        
                      rel="noopener noreferrer"

        
                      className="w-[35px] h-[35px] bg-[#FF0000] flex justify-center items-center rounded-[8px] no-underline"

        
                      aria-label="Subscribe to our YouTube channel"

        
                    >

        
                      <FaYoutube size={22} color="white" />
                  </a>
                </div>
              </div>
            </div>
    
  </div>
   <div className="w-full text-center justify-end mb-0 border-t border-gray-300 pt-4">
  <p className="text-sm text-gray-400">
    © SmileExpert
    <span className="mx-2 text-gray-600">|</span>
    Powered by{" "}
    <a
      href="https://verdant-soft.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-300 hover:text-blue-400 no-underline font-medium transition-colors duration-300 "
    >
      Verdant Soft
    </a>
  </p>
</div>

</div>





</>
  )
}








